import {Datagrid, List, TextField, Filter, SearchInput, TextInput, CloneButton } from "react-admin";
import * as React from "react";

const PostFilter = (props) => (
    <Filter {...props} variant="outlined">
        <TextInput label="id" source="id" />
        <TextInput label="Name" source="name" />
        <TextInput label="Site" source="siteId" />
        <TextInput label="Location" source="location" />
        <TextInput label="Station Type" source="stationType" />
        <TextInput label="Barcode" source="barcode" />
    </Filter>
);

export const StationList = (props) => {

    return (
        <List
            {...props}
            filters={<PostFilter/>}
            empty={false}
        >
            <Datagrid rowClick="edit" >
                <TextField source="id"/>
                <TextField source="name"/>
                <TextField source="siteId"/>
                <TextField source="location"/>
                <TextField source="stationType"/>
                <TextField source="barcode"/>
                <TextField source="createdby"/>
                {/*<TextField source="createdate"/>*/}
                {/*<TextField source="lastupdate"/>*/}


                <CloneButton/>
            </Datagrid>

        </List>
    );
};

